import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import {
  ApexChart,
  ApexXAxis,
  ApexYAxis,
  ApexStroke,
  ApexDataLabels,
  ApexPlotOptions,
  ApexTooltip,
  ApexTitleSubtitle,
} from 'ng-apexcharts';
import { apiEndPoints } from '../../api/apiEndPoint';
import { DashboardService } from '../../Services/dashboard.service';
import { MasterInformationService } from '../../Services/master-information.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  colors: string[];
  title: ApexTitleSubtitle;
  subtitle: ApexTitleSubtitle;
};

@Component({
  selector: 'app-status-dashboard',
  standalone: true,
  imports: [
    NgApexchartsModule,
    FormsModule,
    CommonModule,
    RouterModule,
    ToastrModule,
  ],
  templateUrl: './status-dashboard.component.html',
  styleUrl: './status-dashboard.component.css',
})
export class StatusDashboardComponent {
  @ViewChild('chart') chart!: ChartComponent;
  selectedCityId: any;
  zoneList: any;
  cityList: any;
  selectedZoneId: any;
  zoneListIndividual: any;
  zoneListCorporate: any;
  zoneListDumpster: any;
  zoneListDumpyard: any;
  getFilterCount: any;

  constructor(
    private renderer: Renderer2,
    private dashService: DashboardService,
    private masterService: MasterInformationService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getCity();
  }

  // ------------------------------ Individual ChartOptions ------------------------------ //

  public individualChartOptions: ChartOptions = {
    series: [{ name: 'Users', data: [320, 180, 500] }],
    chart: { type: 'bar', height: 200, toolbar: { show: false } },
    xaxis: {
      categories: [
        'On Business Users',
        'Off Business Users',
        'Registered Users',
      ],
    },
    stroke: { width: 1, colors: ['#fff'] },
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: { colors: ['#fff'] },
      formatter: (val, opt) =>
        opt.w.globals.labels[opt.dataPointIndex] + ': ' + val,
      offsetX: 0,
      dropShadow: { enabled: true },
    },
    plotOptions: {
      bar: {
        barHeight: '100%',
        distributed: true,
        horizontal: true,
        dataLabels: { position: 'bottom' },
      },
    },
    yaxis: { labels: { show: false } },
    tooltip: {
      theme: 'dark',
      x: { show: false },
      y: { title: { formatter: () => '' } },
    },
    colors: ['#5bc0eb', '#f18f01', '#9bc53d'],
    title: {},
    subtitle: {},
  };

  // ------------------------------ OrderChartOptions ------------------------------ //

  public orderChartOptions: ChartOptions = {
    series: [
      {
        name: 'Requester',
        data: [100, 120, 110, 130, 140, 150, 160, 170, 180, 190, 200, 210],
      },
      {
        name: 'Dumpster',
        data: [200, 180, 220, 240, 250, 260, 270, 280, 290, 300, 310, 320],
      },
      {
        name: 'Dumpyard',
        data: [300, 320, 330, 340, 350, 360, 370, 380, 390, 400, 410, 420],
      },
    ],
    chart: {
      type: 'bar',
      height: 300,
      toolbar: { show: false },
    },
    xaxis: {
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec', 
      ],
      title: {
        text: 'Months',
      },
    },
    stroke: { width: 1, colors: ['#fff'] },
    dataLabels: {
      enabled: true,
      textAnchor: 'middle',
      style: { colors: ['#fff'] },
      offsetX: 0,
      dropShadow: { enabled: true },
    },
    plotOptions: {
      bar: {
        distributed: false, 
        columnWidth: '70%',
        dataLabels: { position: 'top' }, 
      },
    },
    yaxis: {
      labels: { show: true },
      title: { text: 'Completed Orders' },
    },
    tooltip: {
      theme: 'dark',
      x: { show: true },
      y: { title: { formatter: () => 'Orders' } },
    },
    colors: ['#edae49', '#d1495b', '#00798c'],
    title: {
      
    },
    subtitle: {
      
    },
  };

  // ------------------------------ City List API ------------------------------ //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        console.log('Success --->', response);
        this.cityList = response.body.details;
      },
      error: (error) => {
        console.error('API Error:', error);
        console.error('Error Status:', error.status);
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onCityChange(event: Event, userType: any) {
    const selectedCity = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCity;
    this.getZone(userType);
  }

  // ----------------------------------- Get Zone List API ----------------------------------- //

  getZone(userType: any) {
    this.dashService
      .getZoneList(apiEndPoints.zoneList, this.selectedCityId)
      .subscribe({
        next: (response: any) => {
          this.zoneList = response.body.details;

          if (userType === 1) {
            this.zoneListIndividual = this.zoneList;
          } else if (userType === 2) {
            this.zoneListCorporate = this.zoneList;
          } else if (userType === 3) {
            this.zoneListDumpster = this.zoneList;
          } else if (userType === 4) {
            this.zoneListDumpyard = this.zoneList;
          }
        },
        error: (error) => {
          // this.toastr.error(
          //   'An unexpected error occurred zoneeeeeeeeee. Please try again later.',
          //   'Error',
          //   {
          //     timeOut: 3000,
          //     positionClass: 'toast-top-right',
          //     progressBar: true,
          //   }
          // );
        },
      });
  }

  // ----------------------------------- Zone Change Dropdown ----------------------------------- //

  onZoneChange(event: Event) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneId = selectedZoneId;
  }
}
